module.exports = __webpack_public_path__ + "static/media/etat-biberon-grey.ce1c5d37.svg";